import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme, transientOptions } from "shared/lib/styles";

import IconAdd from "./icon-add.svg";
import IconChecked from "./icon-checked.svg";

export const Container = styled.div`
  position: relative;

  inline-size: calc(100vw - 20px);
  max-inline-size: 600px;
  margin: auto;
`;

export const SelectionContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  inline-size: calc(100vw - 20px);
  max-inline-size: 600px;
  padding-block: 24px;
  padding-inline: 20px;

  background-color: #f6f6f6;

  > * + * {
    margin-block-start: 12px;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-inline: unset;
    padding-inline: 100px;
  }
`;

export const ConfirmationContainer = styled(SelectionContainer)`
  padding-block: 24px;
`;

export const Title = styled.div`
  color: #001149;
  font-weight: 300;
  font-size: 24px;
  font-family: ${fontRoboto};
  line-height: 28px;
  text-align: center;
`;

export const ThankYouTitle = styled(Title)`
  font-weight: 400;
`;

export const CheckboxContainer = styled.div`
  > * + * {
    margin-block-start: 16px;
  }
`;

export const StyledIconAdd = styled(IconAdd)`
  flex: none;
`;

export const StyledIconChecked = styled(IconChecked)`
  flex: none;
`;

export const StyledIconConfirmation = styled(IconChecked)`
  flex: none;

  inline-size: 56px;
  block-size: 56px;

  circle {
    fill: #001246;
  }
  path {
    fill: #ffca05;
  }
`;

export const ItemLabel = styled.span`
  flex: 1;

  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 19px;
`;

type ItemProps = { $isChecked: boolean };
export const Item = styled.div<ItemProps>`
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;
  justify-content: space-between;
  align-items: center;

  block-size: 51px;
  padding-block: 8px;
  padding-inline: 20px 16px;

  border-radius: 30px;

  cursor: pointer;

  ${theme.breakpoints.up("mobile")} {
    inline-size: 312px;
  }

  ${props =>
    props.$isChecked
      ? css`
          background: #ffca05;

          ${StyledIconChecked} {
            circle {
              fill: #ffffff;
            }
            path {
              fill: #001246;
            }
          }
        `
      : css`
          border: 1px solid #bbbbbb;

          background: #ffffff;

          ${StyledIconChecked} {
            opacity: 0.2;
            circle {
              fill: #a1a1a1;
            }
            path {
              fill: #a1a1a1;
            }
          }
        `}
`;

export const Description = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
  text-align: center;
`;

type ButtonProps = { $isDisabled?: boolean };

export const Button = styled("button", { ...transientOptions })<ButtonProps>`
  align-items: center;

  padding-block: 15px;
  padding-inline: 50px;

  font-size: 16px;
  font-family: ${fontRoboto};
  text-align: center;
  text-transform: uppercase;

  border: none;
  border-radius: 4px;

  ${props =>
    props.$isDisabled
      ? css`
          color: #000000;

          background: #e5e5e5;

          cursor: not-allowed;
        `
      : css`
          color: #ffffff;

          background: #001246;

          cursor: pointer;
        `}
`;

export const ManageFollowAnchor = styled.a`
  color: #001246;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;

  cursor: pointer;
`;
